import React from "react";
import axios from 'axios';

import { store } from "../../redux/store";
import { connect } from "react-redux";
import history from "../../auth/history";
import './../MoneyTransferComponent/Subtransaction.css';
import './../MoneyTransferComponent/MoneyTransfer.css';
import FooterComponet from "../FooterComponent/FooterComponet";
import $ from "jquery";
import moment, { max } from "moment";
import { v4 as uuidv4 } from 'uuid';
import { Link } from "react-router-dom";
import { setMoneyTransferProgress, setTxnAmount, setTxnsurcharge, setTxntotalAmount, setStatusEnqResponse, setMoneyTransferTotalAmount, setTxnAmount1, setTxnsurcharge1, setTxntotalAmount1, setMoneyTransferProgress1, setStatusEnqResponse1 } from '../../redux/misc-data/misc-data.action';
import ProgressGif from '../../assests/images/progress.gif';
import ProgressStatic from '../../assests/images/progress.jpg';
import MtFailed from '../../assests/images/mtfailed.png';
import MtSuccess from '../../assests/images/mtsuccess.png';
import MtPartial from '../../assests/images/mtpartial.png';
import HeaderCommon from '../HeaderComponent/HeadeCommon';
import Menu from "../MenuComponent/Menu";
import { setCreateOrderRes2, setMoneyTransferProgress2, setStatusEnqResponse12, setStatusEnqResponse2, setTxnAmount2, setTxnsurcharge2, setTxntotalAmount2 } from "../../redux/billpayDetails/billpay.action";
import miscReducer from "../../redux/misc-data/misc-data.reducer";

const httpClient = axios.create();

class BillPayTransferDetails2 extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            phoneNo: this.props.phone,
            moneyTransferFinalStatusCompleted: false,
            finalTransferMessage: '',
            counter: 0,
            exceptionCounter: 0,
            moneyTransferProgress1: ''
        }
    }


    componentDidMount() {
        store.dispatch(setTxnAmount2(''));
        store.dispatch(setTxnsurcharge2(''));
        store.dispatch(setTxntotalAmount2(''));
        // store.dispatch(setMoneyTransferTotalAmount(''));
        store.dispatch(setMoneyTransferProgress2(''));
        store.dispatch(setStatusEnqResponse2(''));

    }

    componentWillUnmount() {
    }


    print = (event) => {
        event.preventDefault();
        window.print();
    }


    render() {
        return (
            <div>
                <HeaderCommon />
                <Menu />
                <div class="main">
                    <div class="right-side">
                        <div class="container-fluid">
                            <div class="row">
                                <div class="col-12">
                                    <div class="card-b" id="rightdiv">
                                        <div id="recenttxn">
                                            <div class="head">
                                                <h3>Billpay Details</h3>
                                                <Link to='/billpay'>
                                                    <button class="dbbtn" type="button">Back</button>
                                                </Link>
                                            </div>
                                            <div class="benedtls">
                                                <div class="row">
                                                    <div class="col-12 col-lg-4 order-lg-2">
                                                        <div class="mtprogess" id="mtrun">
                                                            <img src={MtSuccess} alt="process" class="img-fluid" />
                                                            <h3 class="pending">Successfully processed</h3>
                                                        </div>


                                                    </div>
                                                    <div class="col-12 col-md-6 col-lg-4 order-lg-1">
                                                        <div class="graycard">
                                                            <div class="bankdtl">
                                                                {/* <Avatar name={this.props.selectSender.customer.name} round={true} size="44" alt="" /> */}
                                                                <h5>Operator Name</h5>
                                                                <p>{this.props.biillpayOperator}</p>
                                                            </div>
                                                            <hr />
                                                            <div class="bankdtl">
                                                                <h5>Mobile Number</h5>
                                                                <p>{this.props.billPayMobile}</p>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div class="col-12 col-md-6 col-lg-4 order-lg-3">
                                                        <div class="graycard">
                                                            <div class="bankdtl">
                                                                <h5>Retailer Id</h5>
                                                                <p>{this.props.agentInfo.id}</p>
                                                            </div>
                                                            <hr />
                                                            <div class="acntifsc">
                                                                <h5>Retailer Name</h5>
                                                                <p>{this.props.agentInfo.kioskName}</p>
                                                            </div>

                                                            <div class="acntifsc rtxt">
                                                                <h5>Kiosk Code</h5>
                                                                <p>{this.props.agentInfo.kioskCode}</p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>


                                            <div class="subtxn">
                                                <h4>Sub Transactions</h4>

                                                <div class='subtxn-pending'>
                                                    <div class="col-6 col-md-3 col-lg-3 order-md-1">
                                                        <div class="subtxt txnsts">{'Successfully processed'}</div>
                                                    </div>

                                                    {/* <div class="col-12">
                                                        <div class="subtxt txnsts">

                                                            {this.props.createOrderRes2.response.displayMsg != null &&
                                                                this.props.createOrderRes2.response.displayMsg != '' &&
                                                                this.props.createOrderRes2.response.displayMsg != undefined &&
                                                                <b> Message:  {this.props.createOrderRes2.response.displayMsg}
                                                                </b>
                                                            }
                                                            <br />

                                                            {this.props.createOrderRes2.response.tpsRspMsg != null &&
                                                                this.props.createOrderRes2.response.tpsRspMsg != '' &&
                                                                this.props.createOrderRes2.response.tpsRspMsg != undefined &&
                                                                <b> Third Party message:  {this.state.thirdPartyMsg}
                                                                </b>
                                                            }

                                                        </div>
                                                    </div> */}
                                                    <div class="row">
                                                        <div class="col-6 col-md-2 col-lg-4 order-md-4">
                                                            <div class="subtxt subamunt rtxt">₹ {parseFloat(this.props.transferTotalAmount2)}</div>
                                                        </div>

                                                        <div class="col-12 col-md-4 col-lg-6 order-md-2">
                                                            <div class="subtxt subid">Transaction ID: {this.props.createOrderRes2.orderId}</div>
                                                        </div>

                                                        <div class="col-12 col-md-3 col-lg-4 order-md-3">
                                                            <div class="subtxt">{moment(this.props.createOrderStatusResponse2.time).format('DD-MM-YYYY HH:mm:ss')}</div>
                                                        </div>
                                                    </div>
                                                </div>

                                            </div>



                                            {this.props.createOrderRes2 != '' &&
                                                <div class="paydtl">
                                                    <div class="row">
                                                        <div class="col-12 col-sm-6">
                                                            <div class="orderdetail1">
                                                                <div class="txnhead">Order Details</div>
                                                                <div class="odramt">
                                                                    <p>Order Amount <span>₹ {parseFloat(this.props.transferTotalAmount2).toFixed(2)}</span></p>
                                                                    <p>Commission <span>₹ {parseFloat(this.props.surcharge2).toFixed(2)}</span></p>
                                                                </div>
                                                                <div class="ttlamt">
                                                                    <p>Total Amount <span>₹ {parseFloat(this.props.transferTotalAmount2).toFixed(2) - parseFloat(this.props.surcharge2).toFixed(2)}</span></p>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="col-12 col-sm-6">
                                                            <div class="tnsfrdetail1">
                                                                <div class="txnhead">Transaction Details</div>
                                                                <div class="odramt">
                                                                    <p>Transfer Amount <span>₹ {this.props.transferTotalAmount2 != '' && this.props.surcharge2 != ''

                                                                        ? (parseFloat(this.props.transferTotalAmount2).toFixed(2)) : 0.00}</span></p>
                                                                    <p>Commission <span>₹ {this.props.surcharge1 != ''

                                                                        ? parseFloat(this.props.surcharge2).toFixed(2) : 0.00}</span></p>
                                                                </div>
                                                                <div class="ttlamt">
                                                                    <p>Total Amount <span>₹ {this.props.transferTotalAmount2 != '' && this.props.surcharge2 != ''
                                                                        ?
                                                                        parseFloat(this.props.transferTotalAmount2).toFixed(2) - parseFloat(this.props.surcharge2).toFixed(2) : 0.00}</span></p>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            }


                                            {/* <div class="txn-btn">
                                                <button type="button" class="print" onClick={this.print}>Print</button>
                                                <button type="button" class="help"></button>
                                            </div> */}


                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <FooterComponet />
            </div>

        );
    }
}


const mapStateToProps = (
    { errorMessageReduce: { errorMessage, loginErrorMessage },
        billpayReduce: { biillpayOperator, billPayMobile, billpayAmount, surcharge2, transferTotalAmount2, billPayOptional,
            createOrderRes2, createOrderStatusResponse2 },
        miscReduce: { agentInfo, token, clientRole }
    },
) => ({
    errorMessage, loginErrorMessage,
    biillpayOperator, billPayMobile, billpayAmount, surcharge2, transferTotalAmount2, billPayOptional,
    createOrderRes2, createOrderStatusResponse2,
    agentInfo, token, clientRole
});

export default connect(mapStateToProps, null)(BillPayTransferDetails2);


